{
  "rest400": "Valideringsfeil",
  "image.delete": "Kunne ikke slette bildet. Prøv igjen.",
  "accountSettings.contactInformation.updateError": "Kunne ikke lagre kontakinformasjon. Vennligst prøv igjen.",
  "associate.delete": "Kunne ikke slette samarbeidsparnter. Vennligst prøv igjen.",
  "associate.edit": "Kunne ikke redigere samarbeidspartnere. Vennligst prøv igjen.",
  "attachmentResponseError": "Fant ikke vedleggsfil. Prøv å gå til siden på nytt.",
  "attachmentFilesLoadFailed": "Kunne ikke hente alle vedleggene.",
  "brreg.error": "Kunne ikke hente data fra BrReg. Vennligst prøv igjen.",
  "brreg.notFound": "Ikke funnet i Brønnøysundsregistrene.",
  "city.notFound": "Poststed ikke funnet.",
  "clusterAdvisor.create": "Kunne ikke legge til som rådgiver. Vennligt prøv igjen.",
  "clusterAdvisor.remove": "Kunne ikke fjerne rådgivere. Vennligst prøv igjen.",
  "clusterBoardMember.create": "Kunne ikke legge til styremedlem. Vennligst prøv igjen.",
  "clusterBoardMember.remove": "Kunne ikke fjerne kontakter fra styringsgruppen. Vennligst prøv igjen.",
  "clusterManagement.create": "Kunne ikke legge til klyngeledelse. Vennligst prøv igjen.",
  "clusterMissingManager": "Klyngen mangler klyngeleder",
  "clusterVisionMision.update": "Kunne ikke opppdatere klyngens visjon og misjon. Vennligst prøv igjen.",
  "company.infoNotFound": "Kunne ikke finne informasjon om bedriften. Vennligst prøv igjen.",
  "companyCreate": "Kunne ikke opprette ny bedrift. Vennligst prøv igjen.",
  "companyInformation.update": "Kunne ikke oppdatere selskapsinformasjon. Vennligst prøv igjen.",
  "companyUpdate": "Kunne ikke oppdatere bedrift. Vennligst prøv igjen.",
  "contact.add.interestArea": "Kunne ikke legge oppdatere interesseområder for kontakt.",
  "contact.couldNotCreate": "Kunne ikke opprette kontakt. Vennligst prøv igjen.",
  "contact.edit": "Kunne ikke oppdatere kontakt. Vennligst prøv igjen.",
  "contact.remove.interestArea": "Kunne ikke fjerne interesseområder for kontakt.",
  "contact.update.information": "Kunne ikke oppdatere kontakinformasjon.",
  "contacts.delete": "Kunne ikke slette kontaktene. Vennligst prøv igjen.",
  "contacts.edit": "Kunne ikke redigere kontaktene. Vennligst prøv igjen.",
  "couldNotCreateGeneric": "Kunne ikke opprette {{ value }}. Vennligst prøv igjen.",
  "email.alreadyInUseInList": "Denne e-posten er allerede satt til en annen kontakt i dette skjemaet.",
  "entityNotFound": "{{ entityName }} ikke funnet.",
  "error.FetchingData": "Det oppstod en feil under henting av data. Vennligst prøv igjen.",
  "error.EditEventWithTimeEntries": "Dato kan ikke redigeres dersom egeninnsats har blitt registrert på eventet.",
  "errorButSaved": "Det har skjedd en feil men dataene er lagret.",
  "errorCode.BothReqularAndCustom": "Både standard finansieringskilde og egendefinert kan ikke brukes samtidig",
  "errorCode.EndDateBeforeStartDate": "Sluttdato kan ikke være før startdato",
  "errorCode.FileTypeNotSupported": "Filtypen er ikke støttet ",
  "errorCode.GreaterThanOrEqualToZero": "{{fieldName}} må være større eller lik 0",
  "errorCode.GreaterThanZero": "{{fieldName}} må være større enn 0",
  "errorCode.InvalidOrganizationNumber": "Ugyldig organisasjonsnummer",
  "errorCode.MissingFinanceSource": "Finansieringskilde og egendefinert navn kan ikke begge være tomme",
  "errorCode.NotFound": "{{fieldName}} ble ikke funnet",
  "errorCode.Required": "{{fieldName}} må fylles ut",
  "excel.import.error": "Noe gikk galt under importering av Excel-filen. Kan være forskjell på ditt Excel-skjema og mal. Last ned mal og prøv igjen.",
  "excel.validation.title": "Feil som ble oppdaget i Excel-skjema",
  "fieldCannotBeBlank": "Feltet kan ikke være blankt",
  "focusArea.create": "Kunne ikke opprette fokusområde. Vennligst prøv igjen.",
  "focusArea.update": "Kunne ikke oppdatere fokusområdet. Vennligst prøv igjen.",
  "frontend.ErrorBoundaryTitle": "Det har oppstått en feil, kontakt oss og referer til id som vises på siden",
  "generic.create": "Noe gikk galt med opprettelsen. Vennligst prøv igjen.",
  "leads.delete": "Kunne ikke slette alle leads. Vennligst prøv igjen.",
  "leads.edit": "Kunne ikke redigere leads. Vennligst prøv igjen.",
  "leadsNotApproved": "Kunne ikke godkjenne leads til medlemmer. Prøv igjen.",
  "least1RowForAction": "Du må velge minst en rad for å gjøre denne handlingen.",
  "mainGoal.create": "Kunne ikke opprette hovedmål. Vennligst prøv igjen.",
  "mainGoal.update": "Kunne ikke oppdatere hovedmål. Vennligst prøv igjen.",
  "member.addContacts": "Kunne ikke legge til alle kontakene. Vennligst prøv igjen.",
  "member.couldNotCreate": "Kunne ikke opprette medlem. Vennligst prøv igjen.",
  "member.create.plural": "Noe gikk galt under opprettelsen av medlemmene. Vennligst prøv igjen.",
  "member.massDelete": "Kunne ikke slette alle medlemmer. Vennligst prøv igjen.",
  "member.massUpdate": "Kunne ikke redigere alle medlemmene. Vennligst prøv igjen.",
  "member.removeContacts": "Kunne ikke fjerne alle kontaktene fra medlem. Vennligst prøv igjen.",
  "member.removeInterestArea": "Kunne ikke fjerne interesseområder fra medlem. Vennligst prøv igjen.",
  "member.update": "Kunne ikke oppdatere medlem. Vennligst prøv igjen.",
  "member.update.mainContact": "Kunne ikke oppdatere hovedkontakt for medlem. Vennligst prøv igjen.",
  "member.updateInterestArea": "Kunne ikke oppdatere interesseområder for medlem. Vennligst prøv igjen.",
  "memberFee.create": "Kunne ikke opprette medlemskontingen. Vennligst prøv igjen.",
  "memberFee.delete": "Kunne ikke slette medlemskontingent. Vennligst prøv igjen.",
  "memberFee.update": "Kunne ikke oppdatere medlemskontingent. Vennligst prøv igjen.",
  "noClusterChosen": "Ingen klynge valgt. Vennligst velg klynge før denne handlingen kan utføres.",
  "noClusterMemberId": "Ingen medlemsid funnet. Prøv å gå til siden på nytt.",
  "noFileSelected": "Fant ikke fil. Prøv å velg på nytt.",
  "onewayinLeadNoCreateDto": "Kunne ikke opprette lead. Prøv å lukke og åpne modalen på nytt.",
  "only1RowToChangeRole": "Du kan kun endre rolle for en person om gangen.",
  "organizationNumber.alreadyInUse": "Organisasjonsnummer allerede i bruk.",
  "organizationNumberAlreadyInUse": "Organisasjonsnummer allerede i bruk.",
  "portalInvitation.send": "Kunne ikke sende portalinvitasjoner. Vennligst prøv igjen.",
  "postCode.notFound": "Poststed ikke funnet for dette postnummeret.",
  "projectCategory.create": "Kunne ikke opprette ny prosjektkategori. Sjekk at samme navn ikke allerede eksisterer og prøv på nytt.",
  "requiresOneFile": "Må ha minst en fil som vedlegg",
  "rest401": "Ikke autentisert",
  "rest403": "Ikke autorisert",
  "rest404": "Kunne ikke finne {{ entityName }}",
  "rest409": "Din endring kan ha kommet i konflikt med andres endringer, prøv på nytt",
  "rest500": "Der har skjedd en kritisk feil",
  "roles.update": "Kunne ikke oppdatere rolle for {{ name }}. Vennligst prøv igjen.",
  "selfEffort.couldNotImport": "Kunne ikke laste opp egeninnsats. Sjekk at regnearket følger malen.",
  "selfEffort.couldNotRegister": "Kunne ikke redigere egeninnsats. Sjekk at regnearket følger malen.",
  "selfEffort.newContactInvalidEmail": "Kunne ikke opprette ny kontakt med ugyldig epost {{ email }}.",
  "selfEffort.newContactNoEmail": "Kunne ikke opprette ny kontakt med tom epost {{ email }}.",
  "selfEffort.newContactsCreateError": "Kunne ikke opprette kontakter. Dobbeltsjekk at du følger regnearkmalen og prøv igjen.",
  "selfEffort.newMemberCouldnotCreate": "Kunne ikke opprette medlem med organisasjonsnummer {{ orgNumber }}.",
  "selfEffort.newMemberCouldNotSave": "Kunne ikke lagre og hente nyeste medlem('{{ member }}')",
  "selfEffortNotApproved": "Kunne ikke godkjenne egeninnsats. Prøv igjen.",
  "somethingWentWrongTryAgain": "Noe gikk galt. Prøv igjen.",
  "tooBigFile": "For stor fil.",
  "undefinedProperty": "\"{{ property }}\" kan ikke være udefinert.",
  "unretire.contact": "Kunne ikke melde inn kontakt. Vennligst prøv igjen.",
  "unretire.member": "Kunne ikke melde inn medlem. Vennligst prøv igjen.",
  "user.UserHasMultipleClusters": "Brukeren har flere klynger, klynge-ID må angis",
  "validation.email": "Ikke gyldig e-post adresse.",
  "validation.maxValue": "Verdien kan ikke være større enn {{ value }}",
  "validation.minValue": "Verdien kan ikke være mindre enn {{value }}",
  "validation.missingFileName": "mangler filnavn",
  "validation.organizationNumber": "Ikke gyldig organisasjonsnummer.",
  "validation.postalCode": "Ikke gyldig postnummer.",
  "validation.required": "Dette feltet er påkrevd.",
  "validation.uniqueEmailInClusterContacts": "Denne e-posten er allerede i bruk av en annen kontakt i denne klyngen.",
  "wrongFileFormat": "Feil filformat.",
  "notFound.title": "Oisann, her var det ingenting",
  "notFound.subtitle1": "404: Siden du prøvde å gå til ble ikke funnet",
  "notFound.subtitle2": "Det kan hende det du ser etter ikke lenger eksisterer, eller du har logget deg inn under en annen aktør. Sjekk gjerne om du har logget deg inn under riktig aktør.",
  "noClusterUserId": "Ingen brukerId funnet, prøv igjen.",
  "noOnboardingPacketId": "Ingen oppstartsflyt ID ble funnet, prøv å laste inn siden på nytt.",
  "malwareDetected": "Filen inneholder potensielt skadelig innhold og er derfor blokkert. Du kan prøve å laste opp en annen fil."
}
